import * as S from './styled';
import * as Type from '../../types';
import { ReactComponent as Logo } from '../../assets/contributeto-logo.svg';

interface MenuProps {
	layout: Type.LayoutType;
	amounts: Type.AllAmounts;
	dialogHeader: Type.DialogHeader;
	dialogContent: Type.DialogContent;
	spacious: boolean;
}

const PopupPreviewHeading = () => <S.Heading>Pop-up preview</S.Heading>;

const ContributionMenu = ({ layout, amounts, dialogHeader, dialogContent, spacious }: MenuProps) => {
	const ButtonPreview = () => (
		<S.ButtonPreview>
			<S.Heading>Button preview</S.Heading>
			<S.Button disabled>
				<span>{dialogHeader}</span>
			</S.Button>
		</S.ButtonPreview>
	);

	return (
		<S.Container>
			{layout === 'button' && <ButtonPreview />}

			{layout === 'button' && <PopupPreviewHeading />}
			<S.Menu layout={layout} spacious={spacious}>
				<S.Inner>
					<S.Title>{dialogHeader}</S.Title>
					{dialogContent && <S.Content>{dialogContent}</S.Content>}
					<S.Amounts>
						{amounts.map((number, index) => (
							<S.Amount key={`${number}_${index}`}>${number.toFixed(2)}</S.Amount>
						))}
						<S.Amount>Custom</S.Amount>
					</S.Amounts>
					{(layout === 'footer' || layout === 'bar') && (
						<S.PoweredBy>
							Powered by <Logo />
						</S.PoweredBy>
					)}
				</S.Inner>
			</S.Menu>
		</S.Container>
	);
};

export default ContributionMenu;
